import type { GameStateManager } from '../game/GameState';
import type { GameSpeed, GameData } from '../game/types';
import { AudioManager } from '../audio/AudioManager';

export class SpeedControls {
  constructor(
    private container: HTMLElement,
    private gameState: GameStateManager,
    private gameData: GameData,
    private onSpeedChange: (speed: GameSpeed) => void
  ) {
    this.setup();
  }

  private setup(): void {
    const speeds: GameSpeed[] = ['pause', '1x', '2x', '4x'];
    const strings = this.gameData.uiStrings;
    const speedControlLabel = strings.labels?.speed_control || 'Speed control';
    
    this.container.innerHTML = `
      ${speeds.map(speed => 
        `<button class="speed-button ${speed === 'pause' ? 'pause-button' : ''}" data-speed="${speed}">${speed === 'pause' ? '<span class="pause-symbol">⏸</span>' : speed}</button>`
      ).join('')}
      <div class="speed-control-label">${speedControlLabel}</div>
    `;

    this.container.querySelectorAll('.speed-button').forEach(button => {
      button.addEventListener('click', () => {
        AudioManager.getInstance().playClick();
        const speed = (button as HTMLElement).dataset.speed as GameSpeed;
        this.onSpeedChange(speed);
      });
    });

    this.update();
  }

  setSpeed(speed: GameSpeed): void {
    this.onSpeedChange(speed);
  }

  getCurrentSpeed(): GameSpeed {
    return this.gameState.getGameSpeed();
  }

  getNextSpeed(): GameSpeed {
    const current = this.getCurrentSpeed();
    const speeds: GameSpeed[] = ['pause', '1x', '2x', '4x'];
    const currentIndex = speeds.indexOf(current);
    const nextIndex = (currentIndex + 1) % speeds.length;
    return speeds[nextIndex];
  }

  getPreviousSpeed(): GameSpeed {
    const current = this.getCurrentSpeed();
    const speeds: GameSpeed[] = ['pause', '1x', '2x', '4x'];
    const currentIndex = speeds.indexOf(current);
    const previousIndex = (currentIndex - 1 + speeds.length) % speeds.length;
    return speeds[previousIndex];
  }

  update(): void {
    const currentSpeed = this.gameState.getGameSpeed();
    this.container.querySelectorAll('.speed-button').forEach(button => {
      const speed = (button as HTMLElement).dataset.speed;
      if (speed === currentSpeed) {
        button.classList.add('active');
      } else {
        button.classList.remove('active');
      }
    });
  }
}


